angular.module('Directives')
.directive('ngBreadcrumbs', function(){
    return {
        restrict: 'E',
        templateUrl: '/templates/directives/ngBreadcrumbs.html',
        replace: true,
        controller: ngBreadcrumbs
    }

    ngBreadcrumbs.$inject = [
        '$scope',
        '$location',
        '$route',
        '$routeParams',
        '$rootScope'
    ];

    function ngBreadcrumbs(
        $scope,
        $location,
        $route,
        $routeParams,
        $rootScope
    ){
        let menuItems = {};
        const itemMenu =[];
        for (var i in $route.routes) {
            if ($route.routes[i].params && $route.routes[i].params.mainMenu) {
                if ($route.routes[i].params.name) {
                    menuItems[$route.routes[i].params.name] = $route.routes[i];
                }
                itemMenu.push($route.routes[i])
            }
        }

        buildBreadcrumbs($scope.$root.currentRouteParams);
        $scope.$root.$on('$routeChangeSuccess', function(event, current){
            if(angular.isDefined(current.$$route)){
                buildBreadcrumbs(current.$$route.params);
            }
        });

        function buildBreadcrumbs(currentRouteParams){
            let currentUrl = $location.url();
            let urlParams = currentRouteParams;
            $scope.breadcumbLink = [];
            itemMenu.forEach(item=>{
                let verifyUrl = currentUrl.split(/[\?/,]+/)[1]
                if(item.originalPath === '/'+ verifyUrl){
                    urlParams = item.params
                }
            })

            if(angular.isDefined(urlParams)){
                if(urlParams.parent){
                    switch(urlParams.parent){
                        case 'client':
                        urlParams.parent = 'clients';
                        break;
                        case 'api-access':
                        urlParams.parent = 'APIAccess';
                        break;
                    }
                }

                let parentRoute = urlParams.parent ? menuItems[urlParams.parent] : urlParams;
                parentRoute = angular.isDefined(parentRoute.params) ? parentRoute.params : parentRoute;
                parentRoute.url = parentRoute.name === 'carriers' ? `/${parentRoute.name}/carrier-profiles` : `/${parentRoute.name}`;
                $scope.breadcumbLink.push(parentRoute);

                if(parentRoute.hasSubMenu){
                    let subRoute = parentRoute.subMenus.find(route=>{
                        if(urlParams.subParent)
                            return route.name === urlParams.subParent;
                        else 
                            return route.url === currentUrl;
                    });

                    if(subRoute !== undefined) {
                        $scope.breadcumbLink.push(subRoute);
                    }

                    if(urlParams.deepMenuParent) {
                        if(urlParams.deepMenuParent.withfilter){
                            if($location.search()[urlParams.deepMenuParent.filterName]) { 
                                let filterVal = $location.search()[urlParams.deepMenuParent.filterName];
                                let url = urlParams.deepMenuParent.url.replace(/:id/i, filterVal);
                                urlParams.deepMenuParent.url = url;
                                $scope.breadcumbLink.push(urlParams.deepMenuParent);
                            }
                        } else {
                            urlParams.deepMenuParent.url = buildURL($routeParams, urlParams);
                            $scope.breadcumbLink.push(urlParams.deepMenuParent);
                        }
                    }

                    if(urlParams.subParent) {
                        let deepUrl = {
                            itemText : urlParams.pageTitle,
                            url: currentUrl
                        }

                        if(angular.isDefined(subRoute)){
                            if(currentUrl !== subRoute.url) {
                                $scope.breadcumbLink.push(deepUrl);
                            }
                        } else {
                            $scope.breadcumbLink.push(deepUrl);
                        }
                    }
                }
            }
        }

        function buildURL(routeParams, urlParams) {
            let paramsKeys = Object.keys(routeParams);
            let url = urlParams.deepMenuParent.url;

            angular.forEach(paramsKeys, (val)=>{
                url = url.replace(new RegExp(`:${val}`, 'gi'), routeParams[val]);
            });
            return url;
        }
    }
});


// WEBPACK FOOTER //
// ./js/directives/ngBreadcrumbs.js